import React, { useState, useEffect, useRef} from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { BsSearch } from "react-icons/bs";
import ThemeControls from "../AllThemesControl";
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { BsFiletypeXls, BsFiletypeXlsx, BsDownload, BsChevronCompactLeft, BsEnvelope, BsFiletypeCsv  } from "react-icons/bs";
import Typography from '@mui/material/Typography';
import TableSortLabel from '@mui/material/TableSortLabel';
import { ReactComponent as Edit } from '../../images/Table/Edit.svg';
import { ReactComponent as Bin } from '../../images/Table/Bin.svg';
import { ReactComponent as View } from '../../images/Table/Eye.svg';
import { BiDetail } from "react-icons/bi";
import Loading from '../../images/Table/Loading.gif';
import { FormJSONCreateContext } from '../FormJSONCreateContext';
import DeleteTableRow from './Delete';
import EditForm from '../Forms/EditForm';
import Preview from "./Preview.js";
import Details from "./Details.js";
import { MasterContext } from '../../services/MasterContext';
import ApproveReject from "./ApproveReject.js";
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { visuallyHidden } from '@mui/utils';
import { FormContext } from '../Forms/FormContext';
import Element from "../../FormsControls/Element"
import { VscSend, VscClose } from "react-icons/vsc";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useMediaQuery from '@mui/material/useMediaQuery';
import EmailTemplateForm from '../Template/EmailTemplate.js'
import delJSON from './DeleteJson.json';
import cusJSON from './CusJson.json';
import {downloadXLSX, downloadXLS, downloadCSV} from './FlieDowFunction.js'
import { InputAdornment, TextField } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import copy from "copy-to-clipboard";
//APISERVICES
import { APIGET, APIPATCH, APIPOST } from '../../services/APIServices.js';

//Navigation
import { useNavigate } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function EnhancedTableToolbar(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [fileType, setFileType] = React.useState(false);
  const [sendMail, setSendMail] = React.useState(false);
  const {formFieldsJson,dataSource,setDataSource, numSelected,calculateTotalSum, selected, postingData,backupDataCall, setBtnLoading, apiContextObj, setOpenMail, _columns, filteredData , setOpenDel, deleteType} = props;
  const isDisabled = dataSource.length === 0;

  const handleInputChange = (e) => {
    let value = e.target.value

    if (value) {
      const filteredResult = filteredData.filter((item) => {
        return Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(value.toLowerCase())
        );
      });
      // console.log(filteredResult)
      if (filteredResult.length > 0) {
        setDataSource(filteredResult)
      }
    }

  }

   function SendMail(path) {
    const ids = selected.join(',');
    const url = path+'/'+ids
    async function handlesendmail(url) {
    try {
      const data = await APIGET(url);
      setBtnLoading(null)
      if (data.statusCode==="Success" || data.statusCode==="SUCCESS") {
        backupDataCall()
        alert(data.serverMsg)
      }else if(data.statusCode==="Internal Server Error"){
        alert(data.serverMsg)
        // backupDataCall()
      }
    }
    catch (error) {
      setBtnLoading(null)
    }
  }
  handlesendmail(url)
  }

  function finalizeInvoice(path) {
    const data = { ids: selected.join(', ') }
    postingData(formFieldsJson, path, data);
  }

  function Recalculate(path) {
    const data = { ids: selected.join(', ') }
    postingData(formFieldsJson, path, data);
  }

  return (
    <Toolbar
      sx={{
        mt: 3,
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%', display:'flex', gap:'6px' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          <div className={classes.filtersearch_2}>
            {/* <input id="searchInputDataTable" type="text" onChange={handleInputChange} className={classes.searchInput} placeholder="Search" /> */}
              <TextField
                placeholder="Search"
                 variant="standard"
                onChange={handleInputChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BsSearch />
                    </InputAdornment>
                  ),
                }}
              />
          </div>
            {apiContextObj?.tableTotal && (
              <>
                {_columns.map((column, i) => (
                  column.total&&<div key={i} className={classes.totalChep}>
                    {`${column.title}: ${calculateTotalSum(dataSource, column)}`}
                  </div>
                ))}
              </>
            )}

        </Typography>
      )}

      {numSelected > 0 ? (
        <>
          {apiContextObj.invoiceBulk && <Tooltip title="Finalize and Send">
            <IconButton>
              <button className={classes.invFinBtn} onClick={() => finalizeInvoice('gtsInvoice/finalizeBulkInvoice')}>
                Finalize and Send
              </button>
            </IconButton>
          </Tooltip>}
          {apiContextObj.invoiceBulk && <Tooltip title="Finalize WithOut Sending">
            <IconButton>
              <button className={classes.invFinBtn} onClick={() => finalizeInvoice('gtsInvoice/finalizeNotSendBulkInvoice')}>
                Finalize WithOut Sending
              </button>
            </IconButton>
          </Tooltip>}
          {apiContextObj?.mailBtn?.auth && <Tooltip title="Send Mail">
            <IconButton>
              <button className={classes.invFinBtn} onClick={()=>SendMail(apiContextObj?.mailBtn?.apiContext)}>
                Send Mail
              </button>
            </IconButton>
          </Tooltip>}
          {apiContextObj?.mailBtn_1?.auth && <Tooltip title="Send Mail">
            <IconButton>
              <button className={classes.invFinBtn} onClick={()=>SendMail(apiContextObj?.mailBtn_1?.apiContext)}>
                Send Delete Request Mail
              </button>
            </IconButton>
          </Tooltip>}
          {apiContextObj.invoiceBulk && <Tooltip title="Recalculate">
            <IconButton>
              <button className={classes.invFinBtn} onClick={() => Recalculate('gtsInvoice/recalculateBulkInvoice')}>
              Recalculate
              </button>
            </IconButton>
          </Tooltip>}
          {/* <Tooltip title="Email">
            <IconButton onClick={() => setSendMail(true)}>
              {sendMail ? <MarkEmailReadIcon /> : <EmailIcon onClick={()=>setOpenMail(false)}/>}
            </IconButton>
          </Tooltip> */}
          {apiContextObj?.deleteFlow?.auth&&(deleteType === 'bulk' || deleteType === 'custom') && <Tooltip title="Delete">
            <IconButton onClick={() => {
              setOpenDel(true)
            }}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>}
        </>
      ) : (
        <div className={classes.fileSection}>
          {(apiContextObj.downloadFlow.pdf || apiContextObj.downloadFlow.xlsx) && <div className={`fileTypeBtn ${fileType ? 'clicked' : ''}`}>
            {(apiContextObj.downloadFlow.xlsx) && <Tooltip title="Xls" className={fileType ? 'btntrs' : 'btntrf'}>
              <IconButton onClick={isDisabled ? null : () => downloadXLS(filteredData, _columns, apiContextObj)}>
                <BsFiletypeXls />
              </IconButton>
            </Tooltip>}
            {(apiContextObj.downloadFlow.xlsx) && <Tooltip title="Xlsx" className={fileType ? 'btntrs' : 'btntrf'}>
              <IconButton onClick={isDisabled ? null : () => downloadXLSX(filteredData, _columns, apiContextObj)}>
                <BsFiletypeXlsx />
              </IconButton>
            </Tooltip>}
            {(apiContextObj.downloadFlow.pdf) && <Tooltip title="Csv" className={fileType ? 'btntrs' : 'btntrf'}>
              <IconButton onClick={isDisabled ? null : () => downloadCSV(filteredData, _columns, apiContextObj)}>
                <BsFiletypeCsv />
              </IconButton>
            </Tooltip>}
            {(apiContextObj.downloadFlow.pdf || apiContextObj.downloadFlow.xlsx) && <Tooltip title={fileType ? "" : "Download"}>
              <IconButton onClick={() => setFileType(!fileType)}>
                {fileType ? <BsChevronCompactLeft /> : <BsDownload />}
              </IconButton>
            </Tooltip>}
          </div>}
          {(apiContextObj.mailFlow.auth) && <Tooltip title="Mail">
            <IconButton >
              <BsEnvelope onClick={()=>setOpenMail(true)}/>
            </IconButton>
          </Tooltip>}
          <Tooltip title="Filter list">
            <IconButton>
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </Toolbar>
  );
}

export default function GenerateTable(obj) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const _columns = obj.viewJson.columns;
  const reportData = obj.reportData
  const setAlertData = obj.setAlertData ? obj.setAlertData : {};
  const { contextJson } = React.useContext(FormJSONCreateContext);
  const apiPath = obj.apiContext;
  const setTableData = obj.setTableData;
  const [dataSource, setDataSource] = useState([]);
  // const Preview = obj.Preview
  const [open, setOpen] = React.useState(false);
  const [editRowOpen, setEditRowOpen] = React.useState(false);
  const [apiContextObj, setapiContextObj] = React.useState(obj.apiContextObj);
  const [openDel, setOpenDel] = React.useState(false);
  const [deleteType, setDeleteType] = React.useState(apiContextObj.deleteFlow.deleteType);
  const [openQr, setOpenQr] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const [openApprove, setApproveView] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  // const [editData, setEditData] = useState();
  const [editPosition, setEditPosition] = useState(undefined);
  const [delPosition, setDelPosition] = useState();
  const [noData, setNoData] = useState(false);
  const [viewPosition, setViewPosition] = useState();
  const [approvePosition, setApprovePosition] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(''); 
  const [errorType, setErrorType] = React.useState('error'); 
  // const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [openMail, setOpenMail] = React.useState(false);
  const [openEp, setOpenEp] = React.useState(false);
  const [indexEp, setIndexEp] = React.useState();
  const [loading, setLoading] = useState(false);
  const [editJson, setEditJson] = useState(obj.EditJson);
  const [tempAPIPath, setTempAPIPath] = useState('')
  const { userRole } = React.useContext(MasterContext)
  const [btnLoading, setBtnLoading] = React.useState();
  // const isDisabled = dataSource.length === 0;
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const formFieldsJson = obj.createJson;
  const searchJsonField = obj?.searchJson;
  //Setting_data for view table.===>
  let navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isAssigned = useRef(false);

  function hendleErrorMsg(msg, err) {
    setErrorMsg(msg)
    setErrorType(err)
    setErrorOpen(true)
  }

  function handleSuccessMsgCreate(res) {
    if (res.dataRecevied.statusCode === "SUCCESS") {
      setErrorMsg('Action completed successfully')
      setErrorType('success')
      setErrorOpen(true)
      setSelected([])
      backupDataCall()
    }
  }

  useEffect(() => {
    setLoading(obj.loading);
    if(obj.loading){
      setDataSource([]);
      setFilteredData([]);
    }
  }, [obj.loading])

  useEffect(() => {
    async function settingData() {
      return await APIGET(apiPath + `/all`).then(data => {
        try {
          if (data) {
          if(data.statusCode==="LARGE_REPORT"){
            obj.setCheckReport(true)
          }
            if(data.data){
              setDataSource(data.data);
              setFilteredData(data.data);
              setTableData(data.data);
            }
            if (data.statusCode === "NOT_FOUND" || data.data.length === 0) {
              setNoData(true)
            } else {
              setNoData(false)
            }
            setLoading(false);
          } else {
            obj.setCheckReport(true)
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false);
        }
      })
    }

    if (apiPath) {
      setLoading(true);
      setDataSource([]);
      setFilteredData([]);
      setTempAPIPath(apiPath)
      settingData();
      setEditRowOpen(false)
    } else if (!apiPath && Array.isArray(reportData)) {
      setDataSource(reportData);
      setFilteredData(reportData);
      if (reportData.length === 0) {
        setNoData(true)
      } else {
        setNoData(false)
      }
    } else {
      console.log('error')
    }

    if(!isAssigned.current){                    
      setNoData(false);
      isAssigned.current = true;
    }

  }, [apiPath, reportData])

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // function descendingComparator(a, b, orderBy) {
  //   if (b[orderBy] < a[orderBy]) {
  //     return -1;
  //   }
  //   if (b[orderBy] > a[orderBy]) {
  //     return 1;
  //   }
  //   return 0;
  // }


const parseDate = (dateStr) => {
  // Try to parse different date formats
  let parsedDate;

  // Format: "MM/DD/YYYY"
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    parsedDate = new Date(dateStr);
  } 
  // Format: "dd-mm-yyyy"
  else if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split('-');
    parsedDate = new Date(`${year}-${month}-${day}`);
  }
  // Format: "yyyy-mm-dd hh:mm:ss"
  else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateStr)) {
    parsedDate = new Date(dateStr);
  } 
  // Return invalid date if format is not recognized
  else {
    parsedDate = new Date(NaN);
  }

  return parsedDate;
};

// Function to handle comparisons for sorting
function descendingComparator(a, b, orderBy) {
  const aValue = a[orderBy];
  const bValue = b[orderBy];

  // Determine if the values are dates
  const isDateA = aValue && !isNaN(parseDate(aValue).getTime());
  const isDateB = bValue && !isNaN(parseDate(bValue).getTime());

  if (isDateA && isDateB) {
    // Date comparison
    return parseDate(aValue) - parseDate(bValue);
  }

  // Determine if the values are numbers
  const isNumericA = !isNaN(parseFloat(aValue)) && isFinite(aValue);
  const isNumericB = !isNaN(parseFloat(bValue)) && isFinite(bValue);

  if (isNumericA && isNumericB) {
    // Numeric comparison
    return parseFloat(aValue) - parseFloat(bValue);
  }

  // String comparison
  if (aValue < bValue) return -1;
  if (aValue > bValue) return 1;
  return 0;
}

// Comparator function for sorting order
function getComparator(order, orderBy) {
  return order === 'asc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Function for stable sort with index preservation
function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// Memoized sorted rows
const visibleRows = React.useMemo(
  () =>
    stableSort(dataSource, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    ),
  [order, orderBy, page, rowsPerPage, dataSource, getComparator],
);

  const NavigateEditFlow = (id, index, data, path) => {
    data.index = index;
      const idToLabel = data?.dataArr[index][apiContextObj?.editFlow?.routeFlow?.idToLabel];
      data.idToLabel = idToLabel;
    if (apiContextObj.editFlow.routeFlow.routes && id && apiContextObj.editFlow.routeFlow.routesCondition) {
      const status = data.dataArr[index][apiContextObj.editFlow.routeFlow.routesCondition];
      data.status = status;
      let pathname = `${path}/${id}`;
      navigate(pathname, { state: data});
    } else if (apiContextObj.editFlow.routeFlow.routes && id) {
      let pathname = `${path}/${id}`;
      navigate(pathname, { state: data });
    }
  };
  const NavigateViewFlow = (id, index, data, path) => {
    data.index = index;
  if (apiContextObj.viewFlow.routeFlow.routes && id) {
      let pathname = `${path}/${id}`;
      navigate(pathname, { state: data });
    }
  };
  const redarectView = (data, path) => {
  if (path) {

      navigate(path, { state: data });
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
    setAlertData(newSelected);
  };


  async function postingData(contextJson, path, data) {

    try {
        const response = await APIPOST(path, data, contextJson, handleSuccessMsgCreate, hendleErrorMsg);
        console.log(response)
        if (response) {
            const responseData = await response.json(); // Assuming response is a JSON object
            console.log(responseData);
            return responseData;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

 

  const applyRateSubmit = (index) => {
    const data = {};
    const json = apiContextObj.applyRateFlow.json;

    json.forEach((item) => {
      data[item.field_id] = dataSource[index][item.field_id];
    });

    // console.log(dataSource[index]);

    const path = apiContextObj.applyRateFlow.apiContext;

    postingData(contextJson, path, data);
  }

  function handleSuccessMsgUpdate(data) {
    if (data.dataRecevied.statusCode === "SUCCESS" || data.dataRecevied.statusCode === "Success") {
      backupDataCall();
      setEditRowOpen()
      setErrorMsg('Successfully Updated')
      setErrorType('success')
      setErrorOpen(true)
    }
  }

  async function updateData(data, index, path) {
    //console.log(path)
    try {
      const response = await APIPATCH(apiContextObj.editFlow.saveContext + path + data[apiContextObj.id], data, formFieldsJson, handleSuccessMsgUpdate, hendleErrorMsg);
      if (response) {
        response.then((responseData) => {
        })
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }



  const handleInvoiceInfo = (id) => {
    if (apiContextObj?.invoiceFlow?.routeFlow?.routes && apiContextObj?.invoiceFlow?.routeFlow?.auth && id) {
      let pathname = `${apiContextObj.invoiceFlow.routeFlow.routes}/${id}`;
      navigate(pathname);
    }
  };

  //Rendering Rows
  function RenderRow(row, index) {
    // const index = props;
    if (index < dataSource.length) {
      let arr = row;
      const postData = arr
      // let arr = dataSource[String(index)];
      let keys = _columns.map((column) => ({
        dataIndex: column.dataIndex,
        valueFormat: column.valueFormat,
        decimalPoints: column.decimalPoints,
        field_type: column.field_type,
        currencySymbol: column.currencySymbol,
      }));


      function setDataOnEdit() {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields.map((field) => {
          if (field.field_id in arr) {
              if(field.field_type !== ""){
                field.field_value = arr[field.field_id]
              }
            if (field.field_runtime_ops) {
              field.field_runtime_ops.forEach(field => {
                if (field.condition)
                  var resultEval;
      
                var stmt = "resultEval = field." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
      
                eval(stmt);
               
                if (resultEval) {
                  eval(field.ops);
                }
              });
            }
            return { ...field, field_value: arr[field.field_id] };
          }
          return field;
        });
        console.log(updatedEditJson)
        setEditJson(updatedEditJson);
      }
      
      const isSelected = (name) => selected.indexOf(name) !== -1;
      const isItemSelected = isSelected(apiContextObj.id?row[apiContextObj.id]:row);

      const labelId = `enhanced-table-checkbox-${index}`;

      function pendingStatus() {
        setApprovePosition(index)
        setApproveView(true)
      }
      function verifyStatus(originalData, index) {
        const contaxt = '/approve/'
        const newData = {
          ...originalData
        };
        async function approveData(data, index, path) {
          //console.log(path)
          try {
            const response = await APIPATCH(apiContextObj.apiContextSave + path + data[apiContextObj.id], data, formFieldsJson, handleSuccessMsgUpdate, {});
            if (response) {
              response.then((responseData) => {
                 
              })
            }
          } catch (error) {
            console.error(error);
            throw error;
          }
        }
        approveData(newData, index, contaxt)
      }
     // have been used function in JSON for eval.(time calculation)    
      function convertToDate(dateStr) {
        const [day, month, year, hour, minute] = dateStr?.split(/[-: ]/);
        return new Date(year, month - 1, day, hour, minute);
      }

      function formatTablecellValue(value, key) {
  
        switch (key.valueFormat) {
          case "number":
            if (value !== null && value !== undefined && value !== "" && !isNaN(value)) {
              value = parseFloat(value).toFixed(key.decimalPoints || 0);
              value = Number(value); // Ensure it remains a number
            } else {
              value = '';
            }
            break;

            case "currency":
              let formattedValue = Number(value).toFixed(key.decimalPoints || 0);
              let crncy = key.currencySymbol + ' ' + formattedValue;
              value = value ? crncy : ''; 
              break;

          case "string":
            value = value ? String(value) : ''; 
            break;
  
          case "date":
            value = value ? String(value) : '';
  
          default:
            value = value || '';
            break;
        }
        return value;
    }

      function tablecellValue(key) {
        if (typeof key.dataIndex === 'string') {
          return formatTablecellValue(arr[key.dataIndex], key);
        } else if (Array.isArray(key.dataIndex)) {
          let value = "";
          for (const item of key.dataIndex) {
            if (item.column) {
              value += String(arr[item.column] || '');
            } else if (item.condition) {
              // console.log(item.condition)
              value += eval(item.condition);
            } else if (item.string) {
              value += item.string;
            }
          }
          return formatTablecellValue(value, key);
        } else {
          // It is neither a string nor an array.
          return null; // Set the return value to null explicitly.
        }
      }

      function checkStatus(auth) {
        if (Array.isArray(auth)) {
          for (const item of auth) {
            if (eval(item.condition)) {
              return true;
            }
          }
          return false;
        } else {
          return auth;
        }
      }

      const handleChange = (id, event, value) => {
        const updatedEditJson = { ...editJson };

        updatedEditJson.fields = updatedEditJson.fields.map((field) => {
          if (id === field.field_id) {
            //console.log(value)
            postData[field.field_id] = value;
            return { ...field, field_value: value };
          }
          return field;
        });

        setEditJson(updatedEditJson);
      };
      // console.log(editJson) 
      const updateRowData=()=>{
        const data={...postData}
        const updatedEditJson = { ...editJson };
        updatedEditJson.fields.map((field) => {
          data[field.field_id] = field.field_value;
        })
        console.log(data)
        updateData(data, index, '/')
     }   

      const editData = {
        formFieldsJson: formFieldsJson,
        dataArr: visibleRows,
        apiContextObj: apiContextObj,
        apiPath: apiPath,
        // close: () => closeEdit(),
        contextJson: obj.createJson,
        contextHeading: obj.contextHeading,
      }
      async function UploadRateSheet() {
        let url = ''
        const id = apiContextObj.uploadFlow.apiContextGet.id;
        if (typeof id === 'string') {
          url = apiContextObj.uploadFlow.apiContextGet.apiContext;
        } else if (Array.isArray(id)) {
          let formattedString = "";
          id.forEach((key) => {
            const value = arr[key];
            if (value !== undefined) {
              formattedString += `${key.toLowerCase()}=${encodeURIComponent(value)}&`;
            }
          });
          url = apiContextObj.uploadFlow.apiContextGet.apiContext + formattedString;
        } else {

        }
       let isConfirm = window.confirm('Are you sure you want to upload Ratesheet?');
        if (url&&isConfirm) {
          setBtnLoading(index)
          try {
            const data = await APIGET(url);
            setBtnLoading(null)
            if (data.statusCode==="Success" || data.statusCode==="SUCCESS") {
              backupDataCall()
              alert('Ratesheet uploaded Successfully')
            }else if(data.statusCode==="Internal Server Error"){
              // alert(data.statusCode)
              backupDataCall()
            }
          }
          catch (error) {
            setBtnLoading(null)
          }
        }
      }
      async function SendDebitCreditNot(row) {

        const id = apiContextObj?.sendDebitCredit.apiContextGet.id;
         let url = apiContextObj?.sendDebitCredit.apiContextGet.apiContext+`/${row[id]}`;

          setBtnLoading(index)
          try {
            const data = await APIGET(url);
            setBtnLoading(null)
            if (data.statusCode==="Success" || data.statusCode==="SUCCESS") {
              // backupDataCall()
              alert('Ratesheet uploaded Successfully')
            }else if(data.statusCode==="Internal Server Error"){
              alert(data.statusCode)
            }
          }
          catch (error) {
            setBtnLoading(null)
          }
      }
      async function handleProcessCdr(index) {
        setBtnLoading(index)
        let url = ''
        const id = apiContextObj?.procesFlow?.apiContextGet.id;
        if (typeof id === 'string') {
          url = apiContextObj?.procesFlow?.apiContextGet.apiContext;
        } else if (Array.isArray(id)) {
          let formattedString = "";
          id.forEach((key) => {
            const value = arr[key];
            if (value !== undefined) {
              formattedString += `${key}=${encodeURIComponent(value)}&`;
            }
          });
          
          formattedString = formattedString.slice(0, -1);

          url = apiContextObj.procesFlow.apiContextGet.apiContext + formattedString;
        } else {

        }
       let isConfirm = window.confirm('Are you sure you want to Process CDR?');
        if (url&&isConfirm) {
          try {
            const data = await APIGET(url);
            if (data.statusCode==="SUCCESS") {
              // backupDataCall()
              setBtnLoading(null)
              alert('CDR Successfully Process')
            }
          }
          catch (error) {
            console.log(null);
            setBtnLoading(false)
            if (error.response && error.response.data && error.response.data.status === 504) {
              alert('Your Process has been submitted. Please check back after some time.');
            }
          }
        }
      }

      function checkRoutesAuth(context, type) {
        // console.log(context);
        const permissions = userRole?.data?.filter(permission => permission.applicationcontext === context);
        
        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                if (permission.accessPersmission === 1 && permission[type] === 1) {
                    return true;
                }
            }
        }
        
        return false;
      }

      function handleDetailsInfo(field_id){
        if(field_id=='mgCustomer'){
          setapiContextObj(obj.viewJson.config_2)
        }else{
          setapiContextObj(obj.viewJson.config)
        }
        setOpenDetails(true); 
        setViewPosition(index)
      }

      return (
        <React.Fragment>
          <TableRow
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            selected={isItemSelected}
            sx={{ cursor: 'pointer' }}
          >
            {(checkStatus(apiContextObj.tableCheckBox)) && <StyledTableCell padding="checkbox">
              <Checkbox
                color="primary"
                disabled={apiContextObj?.tableCheckBoxDisbale? (!checkStatus(apiContextObj?.tableCheckBoxDisbale)):false}
                checked={isItemSelected}
                onClick={(event) => handleClick(event, apiContextObj.id?row[apiContextObj.id]:row)}
                inputProps={{
                  'aria-labelledby': labelId,
                }}
              />
            </StyledTableCell>}
            {keys.map((key) => (
              (String(arr[key.dataIndex]) == 'PENDING') ?
                <StyledTableCell onClick={pendingStatus} value={String(arr[key.dataIndex])}>
                  <div dangerouslySetInnerHTML={{ __html: String(arr[key.dataIndex]) == null ? "" : arr[key.dataIndex] }}>
                  </div>
                </StyledTableCell> :
                checkRoutesAuth(apiContextObj?.applicationContext, 'authorizeP')&&((String(arr[key.dataIndex]) === "null" || String(arr[key.dataIndex]) === "") && key.dataIndex === "varifiedbyusername") ?
                  <StyledTableCell onClick={() => verifyStatus(postData, index)} value={String(arr[key.dataIndex])}>
                    {/* <div dangerouslySetInnerHTML={{ __html: String(arr[key.dataIndex]) == null ? "" : arr[key.dataIndex] }}>
                  </div> */}
                    <span style={{ color: '#0055d4' }}>Verify</span>
                  </StyledTableCell> :
                  (String(arr[key.dataIndex]) !== "null" || arr[key.dataIndex] !== "") && (key.dataIndex === "invoiceid" || key.dataIndex === "invoicenumber") ?
                    <StyledTableCell  value={String(arr[key.dataIndex])}>
                      <div className='invoiceNumber'>
                        <span
                          onClick={() => handleInvoiceInfo(arr[key.dataIndex])}
                          style={{ color: apiContextObj?.invoiceFlow?.routeFlow?.routes ? '#0055d4' : '#1e1e1e' }}>
                          {arr[key.dataIndex] != null ? String(arr[key.dataIndex]) : ""}
                        </span>

                        <IconButton
                          onClick={() => copy(String(arr[key.dataIndex] || ""))} // Ensure it always copies a string value
                          edge="end"
                        >
                          <ContentCopyOutlinedIcon />
                        </IconButton>
                      </div>
                      {/* <div  style={{ color: apiContextObj?.invoiceFlow?.routeFlow?.routes?'#0055d4':'#1e1e1e' }} dangerouslySetInnerHTML={{ __html: String(arr[key.dataIndex]) == null ? "" : arr[key.dataIndex] }} /> */}
                    </StyledTableCell> :
                  (String(arr[key.dataIndex]) !== "null" || arr[key.dataIndex] !== "") && (key.dataIndex === "mgCustomer" || key.dataIndex === "marginAsVendor") ?
                    <StyledTableCell onClick={() => handleDetailsInfo(key.dataIndex)} value={String(arr[key.dataIndex])}>
                      <div style={{ color:'#0055d4'}} dangerouslySetInnerHTML={{ __html: String(arr[key.dataIndex]) == null ? "" : arr[key.dataIndex] }} />
                    </StyledTableCell> :
                  // ( arr['dcl'] && arr['dynamiCreditLimit'] !== "" && key.dataIndex === "dynamiCreditLimit") ?
                  //   <EditDynamiCreditLimit preValue={ arr[key.dataIndex]} rowData={arr}/> :
                  (key?.redarect?.auth) ?
                    <StyledTableCell onClick={() => redarectView(arr[key?.redarect?.id], key?.redarect?.link)} value={String(arr[key.dataIndex])} style={{ color: 'red' }}>
                      <div>{tablecellValue(key)}</div>
                    </StyledTableCell> :
                    <StyledTableCell value={String(arr[key.dataIndex])}>
                      {
                        key.field_type && editRowOpen === index ?
                          <FormContext.Provider value={{ handleChange }}>
                            {editJson.fields && editJson.fields.map((field, i) => {
                              if (field.field_id === key.dataIndex) {
                                return (<Element key={i} field={field} />)
                              }
                            })
                            }
                          </FormContext.Provider> :
                          <div style={{ maxHeight: '400px', overflow: 'auto'}}>
                            {tablecellValue(key) === null ? "" : tablecellValue(key)}
                          </div>
                          // <div style={{ display: 'flex' }}>
                          //   <span></span>
                            
                          // </div>
                      }
                    </StyledTableCell>
            ))}

            {(apiContextObj.tableAction) && <StyledTableCell className='actionTd'>

              {checkStatus(apiContextObj.editFlow.auth) && checkRoutesAuth(apiContextObj?.applicationContext, 'updatesP')&&(
              (apiContextObj.editFlow.btnName)&& apiContextObj.editFlow.routeFlow.auth ? <button className={classes.atnBtn} onClick={() => {NavigateEditFlow(arr[apiContextObj.id], index, editData, apiContextObj.editFlow.routeFlow.routes)}}>{apiContextObj.editFlow.btnName}</button>:
              <IconButton aria-label="expand row" size="mediam" >
                {apiContextObj.editFlow.rowFlow && apiContextObj.editFlow.rowFlow.auth && editRowOpen === index ? <VscSend onClick={updateRowData} /> :
                  <Edit onClick={() => {
                    if (apiContextObj.editFlow.routeFlow.auth) {
                      NavigateEditFlow(arr[apiContextObj.id], index, editData, apiContextObj.editFlow.routeFlow.routes)
                    } else if (apiContextObj.editFlow.popupFlow.auth) {
                      setOpen(true)
                      setEditPosition(index)
                    } else if (apiContextObj.editFlow.rowFlow.auth) {
                      setDataOnEdit()
                      setEditRowOpen(index)
                      setEditPosition(index)
                    }
                  }}
                  />}
              </IconButton>)}

              {apiContextObj.editFlow.rowFlow && apiContextObj.editFlow.rowFlow.auth && editRowOpen === index ? <IconButton aria-label="expand row" size="large" >
                <VscClose onClick={() => { setEditRowOpen(); backupDataCall();}}
                />
              </IconButton> : null}
              {/* {(Authn.actions.hide.download) ? null : <IconButton disabled={arr.scrubStatus === "Ready" ? false : Authn.actions.disable.download} aria-label="expand row" size="small" >
                <Download onClick={() => {
                  window.open(arr.upload, '_blank').focus();
                }}
                />
              </IconButton>} */}
               {(apiContextObj.detailsFlow.auth) && (
                (apiContextObj.detailsFlow.btnName) ? <button className={classes.atnBtn} onClick={() => { setOpenDetails(true); setViewPosition(index) }}>{apiContextObj.detailsFlow.btnName}</button>:
                <IconButton className={classes.atnBtn} aria-label="expand row" size="small" onClick={() => { setOpenDetails(true); setViewPosition(index) }} >
                  <BiDetail />
                </IconButton> 
              )}
               {/* {(apiContextObj.detailsFlow.auth) && (<button className={classes.atnBtn} onClick={() => { setOpenDetails(true); setViewPosition(index) }}>Finalize Mapping</button>)} */}
              {(checkStatus(apiContextObj?.approveRejectFlow?.auth)&& apiContextObj?.approveRejectFlow?.btnName) && <button className={classes.atnBtn} onClick={pendingStatus}>{apiContextObj.approveRejectFlow.btnName}</button>}
              {checkStatus(apiContextObj?.applyRateFlow?.auth) && <button className={classes.atnBtn} onClick={() => applyRateSubmit(index)}>Apply Rate</button>}
              {checkStatus(apiContextObj?.uploadFlow?.auth) && <button className={classes.atnBtn} onClick={UploadRateSheet}>{btnLoading===index ?<div class={classes.loading07} style={{fontSize:'10px'}}>
              <span data-text="L">L</span>
              <span data-text="o">o</span>
              <span data-text="a">a</span>
              <span data-text="d">d</span>
              <span data-text="i">i</span>
              <span data-text="n">n</span>
              <span data-text="g">g</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
          </div>:apiContextObj.uploadFlow.btnName}</button>}
              {checkStatus(apiContextObj?.sendDebitCredit?.auth) && <button className={classes.atnBtn} onClick={()=>SendDebitCreditNot(arr)}>{btnLoading===index ?<div class={classes.loading07} style={{fontSize:'10px'}}>
              <span data-text="L">L</span>
              <span data-text="o">o</span>
              <span data-text="a">a</span>
              <span data-text="d">d</span>
              <span data-text="i">i</span>
              <span data-text="n">n</span>
              <span data-text="g">g</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
          </div>:apiContextObj?.sendDebitCredit?.btnName}</button>}
              {apiContextObj?.endPointFlow?.auth&&<button className={classes.atnBtn} onClick={() => {
                setIndexEp(index)
                setOpenEp(true)
                }}>{arr?.action}</button>}
              {apiContextObj?.procesFlow?.auth&&<button className={classes.atnBtn} onClick={()=>handleProcessCdr(index)} disabled={btnLoading===index}>
              {btnLoading===index ?<div class={classes.loading07} style={{fontSize:'10px'}}>
              <span data-text="L">L</span>
              <span data-text="o">o</span>
              <span data-text="a">a</span>
              <span data-text="d">d</span>
              <span data-text="i">i</span>
              <span data-text="n">n</span>
              <span data-text="g">g</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
              <span data-text=".">.</span>
          </div>:apiContextObj?.procesFlow?.btnName}
              </button>}
              {(checkStatus(apiContextObj?.deleteFlow?.auth)) && checkRoutesAuth(apiContextObj?.applicationContext, 'deleteP')&&<IconButton aria-label="expand row" size="small" >
                <Bin onClick={() => {
                  setDelPosition(index)
                  setOpenDel(true)
                }}
                />
              </IconButton>}
              {(apiContextObj.viewFlow.auth) && <IconButton aria-label="expand row" size="small" >
                <View onClick={() => {
                  if (apiContextObj.viewFlow.routeFlow.auth) {
                    NavigateViewFlow(arr[apiContextObj.id], index, editData, apiContextObj.viewFlow.routeFlow.routes)
                  } else if (apiContextObj.viewFlow.popupFlow.auth) {
                    setViewPosition(index)
                    setOpenView(true)
                  }
                }}
                />
              </IconButton>}
              {/* <IconButton aria-label="expand row" size="small" >
                <Download onClick={()=>generateInvoicePDF(invoiceData)}/>
              </IconButton> */}
            </StyledTableCell>}
          </TableRow>
        </React.Fragment>
      );
    }
  }

//for update table after any action
function getSuccessResponse(res) {
  console.log(res)
  if (res.dataRecevied) {
    if (res.dataRecevied?.data) {
      setDataSource(res.dataRecevied.data);
      setFilteredData(res.dataRecevied.data);
      setLoading(false)
    }
  }
}

async function postingDataBack(data) {
    const path = apiContextObj.apiContextSave;
  try {
    const response = await APIPOST(path, data, formFieldsJson, getSuccessResponse, hendleErrorMsg);
    if (response) {
      return response.data
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function backupDataCall() {
  setLoading(true);
  setDataSource([]);
  setFilteredData([]);
  setSelected([])
  if(tempAPIPath){
    return await APIGET(tempAPIPath + `/all`).then(data => {
      try {
      if (data?.data&&data?.data.length>0) {
        setDataSource(data.data);
            setFilteredData(data.data);
            setTableData(data.data);
      }else{
        setDataSource([]);
        setFilteredData([]);
        setTableData([]);
        setNoData(true)
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
    })
  }else{
    const formData = {}
    Object.keys(contextJson).forEach((key, _i) => {
      if (key !== "xioFEConfig") {

        contextJson[key].fields.forEach(thisField => {

          formData[thisField.field_id] = thisField.field_value;

        });
      }
    }
    );
    if(formData){
      postingDataBack(formData)
    }
  }
}




  const closeEdit = () => {
    setOpen(() => (!(open)));
    setViewPosition(undefined);
    setEditPosition(undefined);
    backupDataCall();
  }
  const closeDelete = () => {
    setOpenDel(() => (!(openDel)));
    setSelected([])
    backupDataCall();
  }
  const closeQr = () => {
    setOpenQr(() => (!(openQr)));
  }
  const closeView = () => {
    setOpenView(() => (!(openView)));
    setViewPosition(undefined);
    setEditPosition(undefined);
  }
  const closeApprove = () => {
    setApproveView(() => (!(openApprove)));
    setApprovePosition(undefined);
    backupDataCall()
  }

  const handleClose = () => {
    setErrorOpen(false);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = dataSource.map((n) => apiContextObj.id?n[apiContextObj.id]:n);
      setSelected(newSelected);
      setAlertData(newSelected)
      return;
    }
    setSelected([]);
    setAlertData([])
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === 'asc';
  //   setOrder(isAsc ? 'desc' : 'asc');
  //   setOrderBy(property);
  
  //   const sortedData = [...dataSource].sort((a, b) => {
  //     const aValue = a[property];
  //     const bValue = b[property];
  
  //     // Determine if the values are numbers or not (based on their content)
  //     const isNumericA = !isNaN(parseFloat(aValue)) && isFinite(aValue);
  //     const isNumericB = !isNaN(parseFloat(bValue)) && isFinite(bValue);
  
  //     if (isNumericA && isNumericB) {
  //       // Numeric comparison
  //       return isAsc ? parseFloat(aValue) - parseFloat(bValue) : parseFloat(bValue) - parseFloat(aValue);
  //     } else {
  //       // String comparison
  //       return isAsc 
  //         ? aValue.toString().localeCompare(bValue.toString()) 
  //         : bValue.toString().localeCompare(aValue.toString());
  //     }
  //   });
  // console.log(sortedData)
  //   setDataSource(sortedData);
  //   setFilteredData(sortedData);
  // };
  

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  function calculateTotalSum(data, column) {
    let totals = 0;

  
    // Iterate through the data and sum up the values for each total column
    data.forEach(item => {
      if (typeof item[column.dataIndex] === 'number') {
        totals += item[column.dataIndex];
    }else{
      let value = Number(item[column.dataIndex]);
      if (!isNaN(value)) {
        totals += value;
      }
    }
    });
    
    if(column.valueFormat==="currency"){
      return column.currencySymbol+' '+Number(totals.toFixed(column.decimalPoints));
    }else{
      return Number(totals.toFixed(2));
    }
   
}

  return (
    <React.Fragment>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={errorOpen} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={errorType} sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog className={classes.popupEdit}
        open={open}
        maxWidth={fullScreen}
        onClose={closeEdit}
        aria-labelledby="responsive-dialog-title"
      >
        {apiContextObj.editFlow.popupFlow.display === "default" ? <EditForm index={editPosition} formFieldsJson={formFieldsJson} dataArr={visibleRows} apiContextObj={apiContextObj} apiPath={apiPath} close={() => (closeEdit())} contextJson={obj.createJson} contextHeading={obj.contextHeading} /> :
        <></>}
      </Dialog>

      <Dialog className={classes.poup}
        open={openDel}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
      >
        <DeleteTableRow index={delPosition} selectedBulk={selected} contextJson={searchJsonField} formFieldsJson={formFieldsJson} deleteType={deleteType} json ={deleteType==='custom'?cusJSON:delJSON} dataArr={visibleRows[delPosition]} close={() => (closeDelete())} apiContextObj={apiContextObj} contextHeading={apiContextObj.contextHeading} policyLabelOnDelete={obj.policyLabelOnDelete} />
      </Dialog>

      <Dialog className={classes.popupEdit}
        open={openView}
        // fullScreen
        maxWidth="md"
        // maxWidth="lg"
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Preview index={viewPosition} dataArr={visibleRows[viewPosition]} close={() => (closeView())} contextJson={obj.createJson} contextHeading={obj.contextHeading} apiContextObj={apiContextObj} />
      </Dialog>
      <Dialog className={classes.popupEdit}
        open={openApprove}
        // onClose={handleClose}
        maxWidth={fullScreen}
        aria-labelledby="responsive-dialog-title"
      >
        <ApproveReject index={approvePosition} dataArr={visibleRows[approvePosition]} close={() => (closeApprove())} contextJson={obj.createJson} apiContextObj={apiContextObj} viewJson={obj.viewJson}/>
      </Dialog>
      <Dialog className={classes.popupEdit}
        open={openDetails}
        // maxWidth="xl"
        maxWidth={fullScreen}
        onClose={() => setOpenDetails(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Details index={viewPosition} dataArr={visibleRows[viewPosition]} apiContextObj={apiContextObj} close={() => setOpenDetails(false)} viewJson={obj.viewJson} contextJson={obj.createJson} searchJson={contextJson}/>
      </Dialog>
      <Dialog
        open={openMail}
        maxWidth='xl'
        close={()=>setOpenMail(false)}
      >
        <EmailTemplateForm close={()=>setOpenMail(false)} contextJson={searchJsonField} apiContextObj={apiContextObj} viewJson={obj.viewJson} />
      </Dialog>

      {loading ?
        <div className={classes.loader}>
          <img src={Loading} alt="Loading..." />
        </div> : (dataSource.length === 0 && noData) ?
          <div className={classes.noData}>
            <p>No data found.</p>
          </div> : (dataSource.length > 0) ?
            <>
              <EnhancedTableToolbar numSelected={selected.length} selected={selected}  apiContextObj={apiContextObj} setOpenMail={setOpenMail} _columns={_columns} filteredData={filteredData} setOpenDel={setOpenDel} deleteType={deleteType} setBtnLoading={setBtnLoading} backupDataCall={backupDataCall} postingData={postingData} calculateTotalSum={calculateTotalSum} formFieldsJson={formFieldsJson} setDataSource={setDataSource} dataSource={dataSource}/>
              <TableContainer className={classes.table}>
                <Table aria-label="customized table" stickyHeader={true}>
                  <TableHead >
                    <TableRow>
                      {(apiContextObj.tableCheckBox) && <StyledTableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          indeterminate={selected.length > 0 && selected.length < dataSource.length}
                          checked={dataSource.length > 0 && selected.length === dataSource.length}
                          onChange={handleSelectAllClick}
                          inputProps={{
                            'aria-label': 'select all desserts',
                          }}
                        />
                      </StyledTableCell>}
                      {_columns.map((column, i) => (column.title&&<StyledTableCell
                        key={i}
                        // align={column.numeric ? 'right' : 'left'}
                        // padding={column.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === column.dataIndex ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === column.dataIndex}
                          direction={orderBy === column.dataIndex ? order : 'asc'}
                          onClick={createSortHandler(column.dataIndex)}
                        >
                          {column.title}
                          {orderBy === column.dataIndex ? (
                            <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      </StyledTableCell>
                      ))}
                      {(apiContextObj.tableAction) && <StyledTableCell>ACTION</StyledTableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {visibleRows.map((arr, index) => (RenderRow(arr, index)))}
                  </TableBody>
                  {(apiContextObj?.tableTotal) && <TableHead> 
                    <TableRow>
                      {_columns.map((column, i) => (
                        <StyledTableCell key={i}>
                          {i === 0 ? "Total" : (column.total ? calculateTotalSum(dataSource, column) : "")}
                        </StyledTableCell>
                      ))}
                      {(apiContextObj.tableAction) && <StyledTableCell></StyledTableCell>}
                    </TableRow>
                </TableHead>}
                </Table>
              </TableContainer>
              <div className={classes.pagination}>
                <TablePagination
                  component="div"
                  labelRowsPerPage='Show row per page'
                  count={dataSource.length}
                  page={page}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 50, 100, 500, 1000, 2000]}
                  showFirstButton 
                  showLastButton
                />
              </div>
            </>
            : null
      }
    </React.Fragment>
  );
}
